import { groupBy, mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getLumberPropertySetKey } from '../slices/lumberPropertySetsSlice';

export const getLumberPropertySetsKeyed = createSelector(
  (state: RootState) => state.lumberPropertySets.lumberPropertySets,
  (lumberPropertySets) => {
    const groups = groupBy(lumberPropertySets, getLumberPropertySetKey);
    if (Object.values(groups).some((value) => value.length !== 1)) {
      console.error('Found lumber properties with same key.');
    }
    return mapValues(groups, (values) => values[0]);
  },
);
